import React from 'react';
import '../Css/Footer.css';

export default function Footer() {
  return <footer>© All Rights Reserved To Cinéchill 2022</footer>;
}
